import { createFileRoute } from "@tanstack/react-router";
import { Settings } from "@/components/settings";

// Update route path to match new location
export const Route = createFileRoute("/_app/$tenantId/settings")({
	component: SettingsRouteComponent,
});

function SettingsRouteComponent() {
	return <Settings />;
}
